import React from 'react';

import { useOneTimeTracking, usePageView } from '../../hooks/useTracking';
import { ModalEnum } from '../../ModalEnum';
import RouteEnum from '../../RouteEnum';
import Tracking from '../../services/Tracking';
import Link from '../Link';
import MobileModal from '../MobileModal';
import T from '../Translate';

import SocialLoginButtons from './SocialLoginButtons';

import styles from './signModal.module.scss';

type Props = {
  onClose(success?: boolean): void;
};

export default function SignUpModal({ onClose }: Props) {
  usePageView('signup');
  const trackSocialClick = useOneTimeTracking((type: ModalEnum) => {
    switch (type) {
      case ModalEnum.APPLE:
        Tracking.track('SIGNUP_VIA_APPLE');
        break;
      case ModalEnum.FACEBOOK:
        Tracking.track('SIGNUP_VIA_FACEBOOK');
        break;
      case ModalEnum.GOOGLE:
        Tracking.track('SIGNUP_VIA_GOOGLE');
    }
  });

  return (
    <MobileModal blackBackdrop onClose={() => onClose(false)} opened size="md">
      <div className={styles.container}>
        <div>
          <T as="h2" className={styles.title} id="modals.signUp.title" />
          <T as="p" className={styles.description} id="modals.signUp.description" />
        </div>

        <SocialLoginButtons
          apple="modals.signUp.apple"
          facebook="modals.signUp.facebook"
          google="modals.signUp.google"
          onSuccess={onClose}
          track={trackSocialClick}
        />

        <T className={styles.separator} id="modals.signUp.separator" />

        <Link
          className="btn btn-primary btn-block"
          onClick={() => onClose(false)}
          to={RouteEnum.USER_REGISTRATION}
          track="SIGNUP_VIA_EMAIL"
        >
          <T id="modals.signUp.email" />
        </Link>

        <div className={styles.bottom}>
          <T as="span" id="signup_already_have_account" />
          <Link onClick={() => onClose(false)} to={RouteEnum.SIGN_IN}>
            <T id="signup_login" />
          </Link>
        </div>
      </div>
    </MobileModal>
  );
}
